import { useRef, useState } from 'react'
import { Modal } from 'antd'

import { uploadFile } from '@/api/chat'
import { message } from '@/App'
import { getFileName } from '@/utils/common'
import PromptEditor from './editor'
import ExampleFile from './exampleFile'
import styles from './index.module.less'
import { configState, configAction, chatAction } from '@/store'
import reportAction from '@/utils/statistic'
import { StatisticActionTypes, StatisticCategoryTypes } from '@/constants'

interface IProps {
  data: any
  open: boolean
  onCancel: () => void
  onOK: () => void
}

const PromptModal = ({ open, data, onCancel, onOK }: IProps) => {
  const fileRef = useRef(null)
  const editorRef = useRef(null)
  const [loading, setLoading] = useState(false)

  const handlSend = (fileData: any, text: string) => {
    const { file_path, file_id, file_size } = fileData
    let payload = {} as any
    if (data.file_type === 'scene' && file_path.endsWith('.mp4')) {
      payload = {
        video: file_path,
        autoplay: true,
      }
    } else if (data.file_type === 'doc') {
      payload = {
        doc: {
          filename: getFileName(file_path),
          fileurl: file_path,
          filesize: file_size,
          fileid: file_id,
        },
      }
    } else {
      payload = {
        [data.file_type]: file_path,
      }
    }
    if (data.title === '信号解读') {
      payload.isSingal = true
    }
    console.log('payload', payload)

    setTimeout(() => {
      chatAction.onUserSubmit({ ...payload, text })
      onOK()
    }, 0)
  }

  const handleOk = async () => {
    const { text } = editorRef.current as any
    if (!text) {
      message.error('请输入指令')
      return
    }
    if (text.length > configState.baseConfig.limitLength) {
      message.error(
        `指令内容过长，请不要超过${configState.baseConfig.limitLength}字`,
      )
      return
    }

    // 发送带文件指令
    if (fileRef.current) {
      const { file, curSelected } = fileRef.current as any
      if (!curSelected) {
        message.error('请上传文件')
        return
      }
      try {
        setLoading(true)
        const payload =
          file && curSelected?.file ? { file } : { url: curSelected.url }
        const { data: fileData } = await uploadFile(payload)
        if (fileData?.riskMessage) {
          message.error(fileData?.riskMessage)
          onOK()
          return
        }
        handlSend(fileData, text)
      } catch (error) {
        // message.error('文件上传失败')
      } finally {
        setLoading(false)
      }
    } else {
      // 发送纯文本
      chatAction.onUserSubmit({
        text,
      })
      onOK()
    }

    reportAction(
      {
        action: StatisticActionTypes.WEB_ACTION_CLICK,
      },
      {
        tag: data?.title,
        block: StatisticCategoryTypes.creativity,
      },
    )

    configAction.changePromptModal(false)
  }

  return (
    <Modal
      title={data.title}
      open={open}
      width={680}
      destroyOnClose
      centered
      onCancel={onCancel}
      wrapClassName={styles.modal}
      okText="发送"
      onOk={handleOk}
      confirmLoading={loading}
    >
      <div className="flex flex-col gap-2">
        <div>
          <div className={styles.title}>输入指令：</div>
          <PromptEditor ref={editorRef} markText={data.real_prompt} />
        </div>
        {!data.file_type || !data.files ? null : (
          <ExampleFile ref={fileRef} data={data} />
        )}
      </div>
    </Modal>
  )
}

export default PromptModal
